import { IContactInfo } from '../types';

export const convertFormValuesToContactInfo = (
  formValues: any,
): IContactInfo => {
  const contactInfo: IContactInfo = {};

  const addressRegex = /^address\d+$/;
  const emailRegex = /^email\d+$/;
  const phoneRegex = /^phone\d+$/;

  Object.keys(formValues).forEach(function (fieldKey) {
    const value = formValues[fieldKey];

    if (value === undefined || value === null || value === '') {
      return;
    }

    if (emailRegex.test(fieldKey)) {
      if (!contactInfo.emails) {
        contactInfo.emails = [];
      }

      contactInfo.emails.push(value);
      return;
    }

    if (phoneRegex.test(fieldKey)) {
      if (!contactInfo.phones) {
        contactInfo.phones = [];
      }

      contactInfo.phones.push(value);
      return;
    }

    if (addressRegex.test(fieldKey)) {
      if (!contactInfo.addresses) {
        contactInfo.addresses = [];
      }

      contactInfo.addresses.push(value);
      return;
    }

    contactInfo[fieldKey] = value;
  });

  return contactInfo;
};
